import moment from 'moment-timezone';
import {
    ORDERS_FIND_REQUEST,
    ORDERS_FIND_RECEIVE,

    ORDERS_FIND_SET_PRICE_BOUNDS,

    ORDERS_FIND_SET_SORTING,
    ORDERS_FIND_SET_FILTER_TIME,
    ORDERS_FIND_SET_FILTER_PRICE,
    ORDERS_FIND_SET_FILTER_SEARCH,
    ORDERS_FIND_SET_FILTER_SUBJECT,
    ORDERS_FIND_SET_FILTER_TYPE,
    ORDERS_FIND_SET_FILTER_GROUP,

    ORDERS_TYPE_ALL,
    ORDERS_TYPE_FAVORITE
} from './actions';

import { ORDERS_HIDE_IN_LISTS } from './../orders/actions';

const sorting = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_FIND_SET_SORTING:
            return Object.assign({}, state, {
                field: action.value,
                isAsc: state.field === action.value ? !state.isAsc : true
            });
        default:
            return state;
    }
}

const filter = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_FIND_SET_FILTER_TIME:
            return Object.assign({}, state, {
                time: action.value
            });
        case ORDERS_FIND_SET_FILTER_PRICE:
            return Object.assign({}, state, {
                priceMin: action.min,
                priceMax: action.max
            });
        case ORDERS_FIND_SET_FILTER_SEARCH:
            return Object.assign({}, state, {
                search: action.value
            });
        case ORDERS_FIND_SET_FILTER_SUBJECT:
            return Object.assign({}, state, {
                subject: [...action.value]
            });
        case ORDERS_FIND_SET_FILTER_TYPE:
            if (action.set) {
                state.type.push(action.value);
                return Object.assign({}, state, {
                    type: [...new Set(state.type)]
                });
            }
            return Object.assign({}, state, {
                type: state.type.filter(item => action.value !== item)
            });
        case ORDERS_FIND_SET_FILTER_GROUP:
            return Object.assign({}, state, {
                group: action.value
            });
        case ORDERS_FIND_SET_PRICE_BOUNDS:
            return Object.assign({}, state, {
                priceMax: (!state.priceMax || state.priceMax > action.max) ? action.max : state.priceMax,
                priceBoundMax: action.max,
                priceStep: action.step
            });
        default:
            return state;
    }
};

const defaultFilter = {
    time: 'all',
    subject: [],
    type: [],
    group: null,
    priceMin: 0,
    priceMax: 0,
    priceBoundMin: 0,
    priceBoundMax: 0,
    priceStep: 0,
    search: ''
}

export const ordersFind = (state = {
    isFetching: false,
    didInvalidate: true,
    numbers: [],
    sorting: { field: 'grade_priority', isAsc: false },
    filter: {
        [ORDERS_TYPE_ALL]: defaultFilter,
        [ORDERS_TYPE_FAVORITE]: defaultFilter,
    }
}, action) => {
    switch (action.type) {
        case ORDERS_HIDE_IN_LISTS:
            return Object.assign({}, state, {
                numbers: state.numbers.filter(number => number !== action.number)
            });
        case ORDERS_FIND_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ORDERS_FIND_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                updatedAt: moment(),
                numbers: action.numbers
            });
        case ORDERS_FIND_SET_SORTING:
            return Object.assign({}, state, {
                sorting: sorting(state.sorting, action)
            });
        case ORDERS_FIND_SET_FILTER_TIME:
        case ORDERS_FIND_SET_FILTER_PRICE:
        case ORDERS_FIND_SET_FILTER_SEARCH:
        case ORDERS_FIND_SET_FILTER_SUBJECT:
        case ORDERS_FIND_SET_FILTER_TYPE:
        case ORDERS_FIND_SET_FILTER_GROUP:
            return Object.assign({}, state, {
                filter: Object.assign({}, state.filter, {
                    [action.typeId]: filter(state.filter[action.typeId], action)
                })
            });
        case ORDERS_FIND_SET_PRICE_BOUNDS:
            return Object.assign({}, state, {
                filter: Object.assign({}, state.filter, {
                    [ORDERS_TYPE_ALL]: filter(state.filter[ORDERS_TYPE_ALL], action),
                    [ORDERS_TYPE_FAVORITE]: filter(state.filter[ORDERS_TYPE_FAVORITE], action),
                })
            })
        default:
            return state;
    }
};

export default ordersFind;


// WEBPACK FOOTER //
// ./src/store/ordersFind/reducers.js